<template>
  <div class="details-page van-clearfix">
    <div class="title">
      <h4>谁看过</h4>
    </div>
    <div class="detailsContent">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="article_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="我也是有底线的~~~"
          @load="onLoad"
        >
          <div class="list_item" v-for="(item,idx) in personList" :key="idx">
            <div class="article_pic_wrap">
              <van-image
                v-if="item.headimgurl"
                height="42"
                width="42"
                :src="item.headimgurl"
                error-icon
              />
              <img
                v-if="!item.headimgurl"
                height="42"
                width="42"
                src="./img/bin.png"
                style="border-radius: 3px;"
              />
            </div>
            <div class="van-multi-ellipsis--l2 article_title">
              <p>
                <span
                  v-if="item.insuredname||item.nickname==null"
                  class="nameSpan"
                >{{item.insuredname?cutString(item.insuredname,6):'访客'}}</span>
                <span
                  class="nameSpan"
                  v-if="item.nickname&&item.insuredname"
                >（{{cutString(item.nickname,6)}}）</span>
                <span
                  class="nameSpan"
                  v-if="item.nickname&&item.insuredname==null"
                >{{cutString(item.nickname,6)}}</span>
                <span class="statusSpan" v-if="item.insuredcode">
                  <img src="./img/build.png" alt style="margin-right: 3px;" />已建档
                </span>
                <span class="statusSpan" v-else>
                  <img src="./img/none.png" alt /> 未建档
                </span>
              </p>
            </div>
            <!-- <div class="iconBox">
              <div v-if="item.insuredcode"><img  src="./img/build.png" alt=""><span>已建档</span></div>
              <div v-else class="lightRed">未建档</div>
            </div>-->
            <div class="clueNum">
              <div v-if="tendsType=='BROWSE'" class="num">
                <img src="./img/visite.png" alt />
                <div style="color:#646D79">浏览&nbsp;{{item.viewCount}}</div>
              </div>
              <div class="time">
                <img src="./img/time.png" alt />
                <div style="color:#646D79">&nbsp;{{item.viewDuration}}s</div>
              </div>
            </div>
            <div class="infoTipBox" @click="editUer(item)">
              <!-- <span>已建档</span> -->
              <p>{{item.insuredcode?'编辑':'建档'}}</p>
              <!-- <img  class="editBtn" @click="editUer(item)"  src="./img/edit.png" alt=""> -->
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <van-popup v-model="handelBox" :close-on-click-overlay="true">
        <img v-if="userHeader!=''" :src="userHeader" alt />
        <img v-else src="./img/bin.png" alt />
        <div class="close" @click="handelBox=false">
          <img src="./img/close.png" alt />
        </div>
        <div class="popupTitle">您可以新增客户，也可以关联已有的客户</div>
        <div>
          <van-button @click="buildDossier">新增客户</van-button>
        </div>
        <div>
          <van-button @click="relevanceDossier">关联客户</van-button>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import URL from "@/api/api";
export default {
  name: "clueDetails",
  data() {
    return {
      searchValue: '',
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,//请求第几页
      pageSize: 10,//每页请求的数量
      total: 0,//总共的数据条数
      personList: [],
      activitie_id: '',
      tendsType: '',
      baseUrl: '',
      handelBox: false,
      customerBox: false,
      userInfo: {},
      clueTimeType: '',
      userHeader: ''
    };
  },
  created() {
    Toast.loading({
      message: '加载中...',
      duration: 0,
      forbidClick: true
    });
    if (location.hostname === "ufc.dtfcloud.com") {
      this.baseUrl = "https://ufc.dtfcloud.com/";
    } else {
      this.baseUrl = "http://www.bjnfbk.com/";
    }
    // this.activitie_id = this.$route.query.activitie_id 
    // this.tendsType = this.$route.query.tendsType 
    this.activitie_id = sessionStorage.getItem('activitie_id')
    this.tendsType = sessionStorage.getItem('tendsType')
    this.clueTimeType = this.$route.query.day;
    this.getDataList(this.activitie_id, this.tendsType, this.clueTimeType);
    // this.getDataList();
  },
  methods: {
    cancel: function () {
      this.$router.go(-1);

    },
    // closePage: function() {
    //    if(window.location.href.split('#')[1].length==1){
    //      WeixinJSBridge.call('closeWindow')
    //    }
    // },
    getDataList(activitie_id, tendsType, date, pageNum) {
      let that = this;
      that.$fetchPost(URL.getClueDetails.url, {
        pageNo: pageNum ? pageNum : that.pageNum,
        activitie_id: activitie_id,
        tendsType: tendsType,
        unionid: localStorage.getItem('unionid'),
        day: date,
        pageSize: 10,
        openId: sessionStorage.getItem('openId')
        // openId:that.$store.state.openId
        // activitie_id: "1d0f21a61248483d81d9c35f05ed433e",
        // openId: "oKwLcv7ZrJN9qrwxhR0eqoKuB1yE",
        // pageNo: 1,
        // pageSize: 10,
        // tendsType: "BROWSE"
      }).then(res => {
        if (res.data.code == '20000') {
          let list = res.data.data.list; //请求返回当页的列表
          that.refreshing = false;
          that.loading = false;
          Toast.clear()
          that.total = res.data.data.total;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          if (this.pageNum > 1) {
            that.personList = [...that.personList, ...list]
          } else {
            that.personList = list
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.personList.length >= that.total) {
            that.finished = true;
          }
          // 如果总页数大于当前页码，页码+1
          if (res.data.data.pages > that.pageNum) {
            that.pageNum++;
          }

        }
      })


    },
    onLoad() {
      this.getDataList(this.activitie_id, this.tendsType, this.clueTimeType);
    },
    onRefresh() {
      this.searchValue = '';
      this.pageNum = 1
      this.finished = false;
      this.getDataList(this.activitie_id, this.tendsType, this.clueTimeType);

    },
    onSearch() {
      this.finished = false;
      this.pageNum = 1;
      this.getDataList(this.activitie_id, this.tendsType, this.clueTimeType);

    },
    // editUer(id){
    //   window.location.href=this.baseUrl+'/centre/myCustomers/index.html?userId='+id+'&openId='+sessionStorage.getItem('openId');
    // },
    editUer(userInfo) {
      if (userInfo.headimgurl) {
        this.userHeader = userInfo.headimgurl;
      }
      sessionStorage.setItem('insuredcode', userInfo.insuredcode)
      sessionStorage.setItem('user_openId', userInfo.openid)
      this.userInfo = userInfo;
      // this.handelBox=true;
      if (this.userInfo.insuredcode) {
        this.$router.push({
          name: 'customerDetails',
          query: {
            firstTransferPerson: sessionStorage.getItem('openId'),
            type: 'edit',
            headimgurl: this.userInfo.headimgurl,
            nickname: this.userInfo.nickname,
            activitie_id: this.activitie_id,
            tendsType: this.tendsType,
            userId: this.userInfo.openid,
            insuredcode: this.userInfo.insuredcode,
            id:this.userInfo.id
          }
        })
      } else {
        this.handelBox = true;
      }
    },
    relevanceDossier() {
      var that = this;
      this.handelBox = false;
      this.$router.push({
        name: 'customerList',
        query: {
          type: 'edit',
          firstTransferPerson: sessionStorage.getItem('openId'),
          headimgurl: that.userInfo.headimgurl,
          nickname: that.userInfo.nickname,
          activitie_id: that.activitie_id,
          tendsType: that.tendsType,
          userId: that.userInfo.openid,
          insuredcode: that.userInfo.insuredcode,
          id:this.userInfo.id
          // type:that.clueType
        }
      })

    },
    buildDossier() {
      var that = this;
      this.handelBox = false;
      this.$router.push({
        name: 'customerDetails',
        query: {
          firstTransferPerson: sessionStorage.getItem('openId'),
          type: 'add',
          headimgurl: that.userInfo.headimgurl,
          nickname: that.userInfo.nickname,
          activitie_id: that.activitie_id,
          tendsType: that.tendsType,
          userId: that.userInfo.openid,
          id:this.userInfo.id
          // tendsType:that.clueType
        }
      })

    },
    cutString(str, len) {
      //length属性读出来的汉字长度为1
      if (str.length * 2 <= len) {
        return str;
      }
      var strlen = 0;
      var s = "";
      for (var i = 0; i < str.length; i++) {
        s = s + str.charAt(i);
        if (str.charCodeAt(i) > 128) {
          strlen = strlen + 2;
          if (strlen >= len) {
            return s.substring(0, s.length - 1) + "...";
          }
        } else {
          strlen = strlen + 1;
          if (strlen >= len) {
            return s.substring(0, s.length - 2) + "...";
          }
        }
      }
      return s;
    }
  }
};
</script>
<style lang="less" scoped>
.details-page {
  position: relative;
  height: 100%;
  background: #f5f5f5;
  // overflow: hidden;
  .search_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
  }
  .title {
    z-index: 999;
    line-height: 40px;
    text-align: center;
    color: #333;
    font-size: 16px;
    background: #fff;
    position: fixed;
    top: 0;
    width: 100%;
    border-bottom: 1px solid #eaeaea;
  }
  .detailsContent {
    padding: 44px 0 0 0;
    // height: 100%;
    background: #f5f5f5;
    display: flex;
    flex: 1;
    // overflow-y: auto;
    .van-pull-refresh {
      width: 100%;
      .article_list {
        display: flex;
        flex-wrap: wrap;
        // padding: 0 10px;
        justify-content: space-around;
        .list_item {
          width: 100%;
          padding: 12px 16px;
          margin-bottom: 4px;
          position: relative;
          background: #fff;
          border-radius: 3px;
          .article_pic_wrap {
            .van-image {
              /deep/.van-image__error,
              /deep/ .van-image__img,
              /deep/ .van-image__loading {
                border-radius: 21px;
              }
            }
          }
          .iconBox {
            position: absolute;
            top: 20px;
            left: 85px;
            width: 300px;
            div {
              img {
                width: 12px;
                height: 12px;
              }
              span {
                position: absolute;
                left: 16px;
                font-size: 12px;
                color: #71757a;
                top: 0px;
                margin-top: -2.5px;
              }
            }
            .lightRed {
              font-size: 12px;
              color: #fe6c76;
            }
          }
          .clueNum {
            position: absolute;
            left: 66px;
            bottom: 12px;
            width: 200px;
            display: flex;
            div {
              font-size: 12px;
              color: #646d79;
              line-height: 24px;
              margin-right: 6px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              img {
                display: inline-block;
                width: 13.5px;
                margin-right: 6px;
                margin-bottom: 1px;
              }
            }
            .time {
              img {
                width: 13px;
                height: 13px;
              }
            }
          }
          .infoTipBox {
            position: absolute;
            top: 22px;
            right: 16px;
            font-size: 12px;
            line-height: 26px;
            width: 66px;
            border-radius: 13px;
            background: #ff6927;
            color: #fff;
            font-size: 12px;
            text-align: center;
            span {
              display: inline-block;
              width: 42px;
              height: 20px;
              color: #fff;
            }
            .editBtn {
              display: inline-block;
              width: 42px;
              line-height: 20px;
              color: #fff;
              // background: #ff6927;
              text-align: center;
              // border-radius: 3px;
              position: absolute;
              right: 0;
            }
          }
          .article_pic_wrap {
            position: relative;
            // border-bottom: 1px solid #eaeaea;
            .badge {
              position: absolute;
              bottom: 4px;
              right: 0;
              width: 46px;
              height: 18px;
              line-height: 18px;
              background-color: #5b9bd5;
              color: #fff;
              text-align: center;
              font-size: 12px;
            }
          }
          .article_title {
            // margin-top: 5px;
            font-size: 16px;
            color: #737373;
            position: absolute;
            // width: 55px;
            top: 12px;
            left: 66px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            p {
              line-height: 20px;
              color: #3a3a3a;
              .nameSpan {
                max-width: 55px;
                // white-space: nowrap;
                // overflow: hidden;
                // text-overflow: ellipsis;
                // font-style: normal;
                // display: inline-block;
              }
              .statusSpan {
                font-size: 14px;
                color: #71757a;
                display: inline-block;
                img {
                  display: inline-block;
                  width: 11px;
                  height: 11px;
                  // vertical-align: middle;
                  margin-left: 3px;
                }
              }
            }
          }
        }
      }
      .van-list {
        /deep/ .van-list__error-text,
        /deep/ .van-list__finished-text,
        /deep/ .van-list__loading {
          width: 100%;
        }
      }
    }
  }
  .van-popup.van-popup--center {
    width: 80%;
    border-radius: 3px;
    padding-bottom: 30px;
    text-align: center;
    img {
      width: 54px;
      height: 54px;
      margin: 0 auto;
      margin-top: 50px;
      border-radius: 3px;
    }
    .close {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 10px;
      right: 10px;
      img {
        width: 22px;
        height: 22px;
        margin: 0;
      }
    }
    div {
      margin-bottom: 18px;
      button {
        display: block;
        width: 190px;
        margin: 0 auto;
        line-height: 44px;
        height: 44px;
        border-radius: 22px;
      }
    }
    div.popupTitle {
      text-align: center;
      font-size: 14px;
      // color: #ff6927;
      line-height: 54px;
      margin-top: 0;
      // border-bottom: 1px solid #ff6927;
      margin-top: 0;
      img {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 5px;
      }
    }
    .van-button {
      color: #fff;
      text-align: center;
      position: relative;
      border: none;
      // border-color: #FF6927;
      background: linear-gradient(90deg, #ff6521 0%, #ffa041 100%);
      box-shadow: 0px 3px 6px #f1b1b1;

      span {
        img {
          width: 20px;
          height: 20px;
          display: inline-block;
          vertical-align: middle;
          margin-top: -3px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>